import { dateUIToBackend } from 'modules/core/lib/dates'

const buildDateRange = (date: Date, daysToGenerate: number, format: number): Date => {
  return new Date(date.getTime() + daysToGenerate * format)
}

const buildFormattedRangeDate = (from: Date, to: Date, locale: string): string => {
  const formattedFrom = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    weekday: 'short',
    month: 'short',
  }).format(from)

  const formattedTo = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    weekday: 'short',
    month: 'short',
    year: 'numeric',
  }).format(to)

  return `${formattedFrom} - ${formattedTo}`
}

/**
 * Converts a date string to backend format if needed.
 * If the date is already in backend format (YYYY-MM-DD), returns it as is.
 * Otherwise, converts it from UI format to backend format.
 */
const convertDateToBackendIfNeeded = (date: string): string => {
  const backendDateRegex = /^\d{4}-\d{2}-\d{2}$/
  if (backendDateRegex.test(date)) {
    return date
  }
  return dateUIToBackend(date)
}

export { buildDateRange, buildFormattedRangeDate, convertDateToBackendIfNeeded }
